import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TABLE_ICONS, TableIconName } from './table-icons';

/** One of the table's 14×14 icons; size it with CSS width/height. */
@Component({
  selector: 'admin-table-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      @for (d of icon.d; track $index) {
        <path [attr.d]="d" fill="currentColor" [attr.fill-rule]="icon.evenOdd ? 'evenodd' : null" [attr.clip-rule]="icon.evenOdd ? 'evenodd' : null" />
      }
    </svg>
  `,
  styles: [':host { display: inline-flex; width: 14px; height: 14px; } svg { width: 100%; height: 100%; }'],
})
export class AdminTableIconComponent {
  @Input({ required: true }) name!: TableIconName;

  get icon() {
    return TABLE_ICONS[this.name];
  }
}
